// si la página se sirve por https y la URL configurada es http://, el
// navegador bloquea la conexión por "contenido mixto" — la subimos a https
// para que un .env mal seteado (http donde debía ir https) no rompa el socket.
const matchPageProtocol = (url: string): string => {
  if (
    typeof window !== "undefined" &&
    window.location.protocol === "https:" &&
    url.startsWith("http://")
  ) {
    return url.replace(/^http:\/\//, "https://");
  }
  return url;
};

// REACT_APP_URL_BACKEND es específico para sockets y en producción a veces
// no queda seteado en el pipeline de build — REACT_APP_BACKEND (el mismo
// origen que ya usan todas las llamadas HTTP) es un respaldo confiable
// porque sabemos que ese sí está bien configurado en cada ambiente.
export const getSocketBaseUrl = (): string => {
  const explicit = process.env.REACT_APP_URL_BACKEND;
  if (explicit) return matchPageProtocol(explicit.replace(/\/+$/, ""));

  const backend = process.env.REACT_APP_BACKEND;
  if (backend) return matchPageProtocol(backend.replace(/\/+$/, ""));

  return "http://localhost:2000";
};
